import { Checkbox, IconButton } from '@mui/material'
import React from 'react'
import './EmailRow.css'
import StarBorderIcon from '@mui/icons-material/StarBorder';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import { useNavigate } from "react-router-dom";
import {useDispatch} from "react-redux";
import { SelectMail, selectselectedmail } from './features/mailSlice';

function EmailRow({id,title,description,subject,time}) {
    const history = useNavigate();
    const dispatch = useDispatch();
    const openmail = () =>{
        dispatch(SelectMail({
            id,
            title,
            description,
            subject,
            time,
        }));
        history('/Mail');
    }

    

  return (
    <div onClick={openmail} className='emailrow'>
        <div className='emailrow_options'>
            <Checkbox/>
            <IconButton>
                <StarBorderIcon/>
            </IconButton>
            <IconButton>
                <LabelImportantIcon/>
            </IconButton>
        </div>
        <h3 className='emailrow_title'>
            {title}
        </h3>
        <div className='emailrow_message'>
            <h4>{subject}{" "}
            <span className='emailrow_description'>  -{" "}
            {description}
            </span>
            </h4>
            
        </div>
        <p className='emailrow_time'>
            {time}
        </p>
    </div>
  )
}

export default EmailRow